import { useSelector } from "react-redux";
import { useAppDispatch } from "../../../../store/hooks/useAppDispatch.ts";
import { selectSelectedStatementLineId } from "../../../../store/selectors/fieldsStateSelectors.ts";
import type { StatementLineState } from "../../../../store/types/fieldsState.types.ts";
import { createFinancialStatementAction } from "../../../../store/utils/storeUtils.ts";
import type { GetFieldCaption } from "../../../viewer/financialStatement/statementGridModel.ts";
import StatementFormulaDialog from "../formulas/StatementFormulaDialog.tsx";
import type { StatementFormula } from "../utils/statementFormulas.ts";
import { getFormulaCycleMessage, getFormulaReferableLines } from "../utils/statementLineOptions.ts";
import { getNewLineAnchor, getStatementLineLabel } from "../utils/statementRowsArea.ts";

interface Props {
  line: StatementLineState;
  isNew: boolean;
  lines: StatementLineState[];
  getFieldCaption: GetFieldCaption;
  onClose: () => void;
}

const FormulaLineDialog = ({ line, isNew, lines, getFieldCaption, onClose }: Props) => {
  const dispatch = useAppDispatch();
  const selectedLineId = useSelector(selectSelectedStatementLineId);

  const getLabel = (candidate: StatementLineState): string => getStatementLineLabel(candidate, getFieldCaption);

  const handleApply = (formula: StatementFormula) => {
    if (isNew) {
      const anchor = getNewLineAnchor(selectedLineId);
      dispatch(createFinancialStatementAction("addLine", { line: { ...line, ...formula }, anchor }));
    } else {
      dispatch(createFinancialStatementAction("updateLine", { guid: line.guid, changes: formula }));
    }
    onClose();
  };

  return (
    <StatementFormulaDialog
      source={line}
      referableFields={getFormulaReferableLines(lines, line.guid, getLabel)}
      referableFieldsTitle="Lines"
      getReferenceError={(formulaParameters) => getFormulaCycleMessage(lines, line.guid, formulaParameters, getLabel)}
      onClose={onClose}
      onApply={handleApply}
    />
  );
};

export default FormulaLineDialog;
